import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReferFriendComponent } from './components/refer-friend/refer-friend.component';
import { ReferFriendPopupComponent } from './components/refer-friend-popup/refer-friend-popup.component';
import { ReactiveFormsModule } from '@angular/forms';
import { InputModule } from '../input/input.module';
import { IntlInputModule } from '../intl-input/intl-input.module';
import { ButtonModule } from '../button/button.module';
import { CloseBtnModule } from '../close-btn/close-btn.module';
import { CommonTalktousModalModule } from '../common-talktous-modal/common-talktous-modal.module';
import { SharedModule } from '../../shared/shared.module';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [ReferFriendComponent, ReferFriendPopupComponent],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    InputModule,
    IntlInputModule,
    ButtonModule,
    CloseBtnModule,
    CommonTalktousModalModule,
    MatButtonModule
  ],
  exports: [ReferFriendComponent]
})
export class ReferFriendModule { }
